





















































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorker from '@/components/JobWorkers/JobWorker.vue'
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';

@Component({
  name: 'JobRejectedWorkers',
  components: { JobWorker, JobWorkerStatus }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	page = 1;
	perPage = 8;

	get selectedJobWorker() {
		return JobDetailsModule.jobWorkersVM.selectedRejectedJobWorker;
	}

	set selectedJobWorker(value: JobWorkerDto) {
		JobDetailsModule.jobWorkersVM.selectedWorkerId = value.workerId;
		JobDetailsModule.jobWorkersVM.selectedRejectedJobWorker = value;
	}
	get currentJob() {
		return JobDetailsModule.currentJob;
	}
	
	get jobWorkers() {
		return JobDetailsModule.jobWorkersVM.jobWorkers;
	}

	get pagedJobWorkers() {
		return this.rejectedWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get rejectedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatusEnum.WorkerNotInterested ||
			jobWorker.status === JobWorkerStatusEnum.ContactNotInterested ||
			jobWorker.status === JobWorkerStatusEnum.Rejected
			))
	}
	
	async onPageChanged(input: number){
		JobDetailsModule.jobWorkersVM.selectedRejectedJobWorker = (this.pagedJobWorkers[0]);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}

}
